import React from 'react';
import { Content, SubTitleWrapper, Wrapper } from './banner-product-info.styles';
import { Typography } from '@shared/ui/typography/typography';
import { BannerProductInfoProps } from './types';
import { datePeriod } from '@shared/lib/utils/date/date';
import { ProductPhoto } from '../product-photo/product-photo';

export const BannerProductInfo: React.FC<BannerProductInfoProps> = ({ product }) => {
    return (
        <Wrapper>
            <ProductPhoto imageUrl={product.imagePath} />
            <Content>
                <Typography size='body2_short' color='neutral_50'>
                    {datePeriod(product.startAt || '', product.endAt || '')}
                    {Boolean(product.place) && ` · ${product.place}`}
                </Typography>
                <SubTitleWrapper>
                    <Typography size='subtitle3' color='neutral_90'>
                        {product.name}
                    </Typography>
                </SubTitleWrapper>
            </Content>
        </Wrapper>
    );
};
